import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from './utils/sentry'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'
import App from './App.tsx'

// Initialize Sentry before React renders
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
